import { apiClient } from "./httpClient";
import { GeneralConfigSectionKey } from "./generalConfigSections";

const MENU_ORDER_URL = `${process.env.REACT_APP_API_URL}/users/me/menu-order`;

export const MENU_ORDER_UPDATED_EVENT = "menu-order:updated";

export const getMyMenuOrder = async (): Promise<GeneralConfigSectionKey[]> => {
  const response = await apiClient.get(MENU_ORDER_URL);
  return (response.data?.order ?? []) as GeneralConfigSectionKey[];
};

export const updateMyMenuOrder = async (
  order: GeneralConfigSectionKey[],
): Promise<GeneralConfigSectionKey[]> => {
  const response = await apiClient.put(MENU_ORDER_URL, { order });
  const updatedOrder = (response.data?.order ?? []) as GeneralConfigSectionKey[];

  window.dispatchEvent(
    new CustomEvent<GeneralConfigSectionKey[]>(MENU_ORDER_UPDATED_EVENT, {
      detail: updatedOrder,
    }),
  );

  return updatedOrder;
};
